import React from "react";
import PropTypes from "prop-types";
import {
  ConfirmationModalWrapper,
  ConfirmationModalContainer,
  ConfirmationModalContent,
  ConfirmationModalButtonsContainer,
} from "./CustomModalStyles";
import Text from "../Common/Text";
import CustomButton from "../CustomButton/CustomButton";
import Colors from "../../themes/Colors";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  highlightedText,
  confirmText,
  cancelText,
  confirmButtonColor,
  cancelButtonColor,
  loading,
}) => {
  if (!isOpen) {
    return null;
  }

  const handleWrapperClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <ConfirmationModalWrapper onClick={handleWrapperClick}>
      <ConfirmationModalContainer onClick={(e) => e.stopPropagation()}>
        <ConfirmationModalContent>
          <Text size="20px" weight="500" margin="0 0 20px 0" textAlign="center">
            {title}{" "}
            {highlightedText && (
              <strong
                style={{
                  color: Colors.primaryPrimera,
                  fontSize: "22px",
                }}
              >
                {highlightedText}
              </strong>
            )}
            ?
          </Text>

          {message && (
            <Text
              size="14px"
              color={Colors.gray}
              margin="0 0 30px 0"
              textAlign="center"
              style={{ fontStyle: "italic" }}
            >
              {message}
            </Text>
          )}

          <ConfirmationModalButtonsContainer>
            <CustomButton
              label={cancelText}
              bgColor={cancelButtonColor}
              hoverColor={Colors.darkGray}
              textColor={Colors.white}
              hoverTextColor={Colors.white}
              onClick={onClose}
              width="120px"
              fontSize="16px"
            />
            <CustomButton
              label={confirmText}
              bgColor={confirmButtonColor}
              hoverColor={Colors.darkRed}
              textColor={Colors.white}
              hoverTextColor={Colors.white}
              onClick={handleConfirm}
              loading={loading}
              width="120px"
              fontSize="16px"
            />
          </ConfirmationModalButtonsContainer>
        </ConfirmationModalContent>
      </ConfirmationModalContainer>
    </ConfirmationModalWrapper>
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  highlightedText: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  confirmButtonColor: PropTypes.string,
  cancelButtonColor: PropTypes.string,
  loading: PropTypes.bool,
};

ConfirmationModal.defaultProps = {
  message: "Esta acción no se puede deshacer.",
  highlightedText: null,
  confirmText: "Confirmar",
  cancelText: "Cancelar",
  confirmButtonColor: Colors.error,
  cancelButtonColor: Colors.gray,
  loading: false,
};

export default ConfirmationModal;
